import React, { useContext } from "react";
import { ProtectedLayout } from "./ProtectedLayout";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { RolePermission } from "../../interfaces/interfaces";

interface Props {
  children: JSX.Element | JSX.Element[];
  role?: null | RolePermission;
}
export const ProtectedRoute = ({ role, children }: Props) => {
  const { validateToken, onLogout, role: userRole, clientList } =
    useContext(AuthContext);
  const location = useLocation();
  const isSuperAdmin = userRole === "SUPER_ADMIN";
  const superAdminHasClients = isSuperAdmin && Boolean(clientList?.length);

  if (!validateToken()) {
    onLogout();
    return <Navigate to="/login" replace />;
  }

  if (
    role &&
    role !== userRole &&
    !(isSuperAdmin && superAdminHasClients && role === "ADMIN")
  ) {
    return <Navigate to="/login" replace />;
  }

  if (
    isSuperAdmin &&
    !superAdminHasClients &&
    !location.pathname.startsWith("/super-admin")
  ) {
    return <Navigate to="/super-admin/users" replace />;
  }

  return <ProtectedLayout>{children}</ProtectedLayout>;
};
